import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'pennant-2', 'Pennant2', [["path",{"d":"M16 21h-4"}],["path",{"d":"M14 21v-18"}],["path",{"d":"M14 4l-9 4l9 4"}]]);